/**
 * @generated SignedSource<<44b9dd60003c02f3a1f8675050c4537d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_user$data = {
  readonly favorites?: {
    readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_favoritesConnection">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_user";
};
export type PdpSharedCondensedSidebarButtons_user$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchFollowSearch"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    },
    {
      "condition": "fetchFollowSearch",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "followSearchPages"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH",
                "USER_PREFERENCE"
              ]
            }
          ],
          "concreteType": "favoritesConnection",
          "kind": "LinkedField",
          "name": "favorites",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SaveSearchButton_favoritesConnection"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "87940c85ffc86d4b1fdd90cd8ae15601";

export default node;
